import DropdownStyles from "./Dropdown.module.scss";

import { Dropdown as DropdownComp } from "antd";
import { DropdownCompType } from "./Dropdown.types";

const Dropdown = ({
  children,
  className,
  trigger = "click",
  items,
  placement = "bottomRight",
}: DropdownCompType) => {
  return (
    <DropdownComp
      placement={placement}
      menu={{ items }}
      trigger={[trigger]}
      className={className}
    >
      <div className={DropdownStyles.dropdownContainer}>{children}</div>
    </DropdownComp>
  );
};

export default Dropdown;
